/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from "relay-runtime";
import { FragmentRefs } from "relay-runtime";
export type Partners = {
    readonly partners: ReadonlyArray<{
        readonly partnerSiteUrl?: string | null;
        readonly picture?: string;
        readonly _name?: string | null;
        readonly _id?: string;
    } | null> | null;
    readonly " $refType": "Partners";
};
export type Partners$data = Partners;
export type Partners$key = {
    readonly " $data"?: Partners$data;
    readonly " $fragmentRefs": FragmentRefs<"Partners">;
};



const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "Partners",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": null,
      "kind": "LinkedField",
      "name": "partners",
      "plural": true,
      "selections": [
        {
          "kind": "InlineFragment",
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "partnerSiteUrl",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "picture",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "_name",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "_id",
              "storageKey": null
            }
          ],
          "type": "PartnerPublishedContent",
          "abstractKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "HomePublishedContent",
  "abstractKey": null
};
(node as any).hash = '821d3d938f02b8b426c9b93102438cdf';
export default node;
